import { createActions } from 'redux-actions';

const action = createActions({
  ADMIN: {
    API: {
      RESET_USER_CPD_PROGRESS_REPORT: () => {}
    },
    RESET_USER_CPD_PROGRESS_REPORT: () => {}
  }
})

const configuration = {
  name: 'resetUserCpdProgressReport',
  action,
  reducers: {
    reducer: (state) => ({
      ...state,
      report: {
        ...(state.report || {}),
        userCpdProgressReport: undefined,
        downloadedUserCpdProgressReport: undefined
      }
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/admin/configurations/resetUserCpdProgressReport.js